// extracted by mini-css-extract-plugin
export default {"timelineArea":"TimelineModal_timelineArea__DxUq-","singleTimelineArea":"TimelineModal_singleTimelineArea__HqRRn","timelineDate":"TimelineModal_timelineDate__wdcOS"};